export default "__VITE_ASSET__BYk84Ujr__"